import style from './styles/IntroductionArea.scss';
import MutationService from '../../../services/MutationService';

const IntroductionArea = ({ raffle }) => {
	const description = raffle.getDescription(MutationService.getMutationCode());
	const paragraphs = description.replace(/\n+/g, '\n').split('\n');
	const paragraphComponents = paragraphs.map(paragraph => <p className={style.description}>{paragraph}</p>);

	return (
		<div className={style['introduction-area']}>
			{paragraphComponents}
		</div>
	);
};

export default IntroductionArea;


// WEBPACK FOOTER //
// ./components/blocks/raffleDetail/IntroductionArea.js